// extracted by mini-css-extract-plugin
export var dropdownButton = "_2r-0";
export var fullWidthDropdownButton = "_2r-1";
export var icon = "_2r-3";
export var iconPlaceholder = "_2r-2";
export var menuItemRow = "_2r-9";
export var separator = "_2r-e";
export var shortcutContainer = "_2r-7";
export var shortcutContainerFilled = "_2r-8";
export var shortcutIconLg = "_2r-6";
export var shortcutIconMd = "_2r-5";
export var shortcutIconSm = "_2r-4";
export var submenuChevron = "_2r-d";
export var submenuDropdown = "_2r-a";
export var submenuTriggerRow = "_2r-b";
export var submenuTriggerRowOpen = "_2r-c";